import debounce from "lodash.debounce";
import { useCallback, useRef } from "react";

export const useDebouncedCallback = (callback, delay) => {
  const debouncedCallback = useRef(debounce(callback, delay));

  return useCallback((...args) => debouncedCallback.current(...args), []);
};
